export default __webpack_public_path__ + "static/media/image-xx99-mark-one.3807b3ee.jpg";